import script from "./MenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItem.vue?vue&type=script&setup=true&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=414d198d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-414d198d"]])

export default __exports__